import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToSection } from "../utils/scrollToSection";

/**
 * Navigation vers une section de la landing (#contact, #pricing, …).
 */
export function useGoToLandingSection() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (sectionId: string) => {
      const isOnHome =
        location.pathname === "/" || location.pathname === "";

      if (isOnHome) {
        window.history.replaceState(null, "", `/#${sectionId}`);
        scrollToSection(sectionId);
        return;
      }

      navigate({ pathname: "/", hash: `#${sectionId}` });
    },
    [location.pathname, navigate]
  );
}
